/**
 * RECO BRANDS — Color Database Loader
 * File: assets/reco-color-db-loader.js
 *
 * Applies hex colors from window.RECO_COLOR_MAP (set by reco-color-db.js)
 * to .reco-mv-swatch elements that are missing a background color.
 */

(function () {

  function buildLowerMap() {
    var map = window.RECO_COLOR_MAP;
    if (!map) return null;
    var lowerMap = {};
    Object.keys(map).forEach(function (k) {
      lowerMap[k.toLowerCase().trim()] = map[k];
    });
    return lowerMap;
  }

  function resolveHex(colorName, lowerMap) {
    var key = (colorName || '').toLowerCase().trim();
    if (!key) return null;

    // 1. Exact match
    if (lowerMap[key]) return lowerMap[key];

    // 2. Strip one-word prefix (e.g. "Pigment Alpine Green" -> "Alpine Green")
    var words = key.split(' ');
    if (words.length > 1) {
      var withoutFirst = words.slice(1).join(' ');
      if (lowerMap[withoutFirst]) return lowerMap[withoutFirst];
    }

    // 3. First word only
    if (lowerMap[words[0]]) return lowerMap[words[0]];

    // 4. Substring — color name contains a known key
    var keys = Object.keys(lowerMap);
    for (var i = 0; i < keys.length; i++) {
      if (key.indexOf(keys[i]) !== -1 || keys[i].indexOf(key) !== -1) {
        return lowerMap[keys[i]];
      }
    }

    return null;
  }

  function applyColors() {
    var lowerMap = buildLowerMap();
    if (!lowerMap) {
      console.warn('[RecoColorDB] window.RECO_COLOR_MAP not found.');
      return;
    }

    var swatches = document.querySelectorAll('.reco-mv-swatch');
    if (!swatches.length) return;

    var applied = 0;

    swatches.forEach(function (el) {
      // Skip swatches that already have a real color applied
      var bg = el.style.backgroundColor || el.style.background || '';
      var hasRealColor = bg && bg !== '' && bg !== 'transparent'
        && bg !== 'rgb(221, 221, 221)' && bg !== '#ddd'
        && !el.classList.contains('reco-mv-swatch--no-color');
      if (hasRealColor) return;

      var colorName = (
        el.dataset.color ||
        el.getAttribute('title') ||
        el.getAttribute('aria-label') || ''
      ).trim();

      var hex = resolveHex(colorName, lowerMap);
      if (hex) {
        el.style.background = hex;
        el.style.backgroundColor = hex;
        el.classList.remove('reco-mv-swatch--no-color');
        applied++;
      }
    });

    if (applied > 0) {
      console.log('[RecoColorDB] Applied ' + applied + ' swatch colors.');
    }
  }

  function init() {
    applyColors();

    // Re-apply after buildSwatches fires (async variant loading)
    document.addEventListener('reco:colorChanged', applyColors);
    document.addEventListener('reco:variantsLoaded', applyColors);

    // Catch async rebuilds with a short delay
    var observer = new MutationObserver(function(mutations) {
      var needsApply = false;
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(n) {
          if (n.classList && n.classList.contains('reco-mv-swatch')) needsApply = true;
          if (n.querySelectorAll) {
            if (n.querySelectorAll('.reco-mv-swatch').length) needsApply = true;
          }
        });
      });
      if (needsApply) setTimeout(applyColors, 50);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
